import React from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';

import { IBorderCardProps } from './types';

import styles from './BorderedCard.module.scss';

export const BorderedCard: React.FC<IBorderCardProps> = ({ borderCardStyles, children }) => (
  <Box className={clsx(styles.sections, borderCardStyles?.container)}>{children}</Box>
);
